import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ZoomImageComponent } from './zoom-image/zoom-image.component';
import { VideoRecorderComponent } from './video-recorder/video-recorder.component';
import { CustomVideoPlayerComponent } from './custom-video-player/custom-video-player.component';
import { CustomAudioPlayerComponent } from './custom-audio-player/custom-audio-player.component';
import { MobileScormPlayerComponent } from './mobile-scorm-player/mobile-scorm-player.component';


@NgModule({
  declarations: [
    ZoomImageComponent,
    VideoRecorderComponent,
    CustomVideoPlayerComponent,
    CustomAudioPlayerComponent,
    MobileScormPlayerComponent,

  ],
  exports: [
    ZoomImageComponent,
    VideoRecorderComponent,
    CustomVideoPlayerComponent,
    CustomAudioPlayerComponent,
    MobileScormPlayerComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MultimediaComponentsModule { }
